import React from 'react';
import { useSelector } from 'react-redux';
import AddProductForm from '../components/AddProductForm';
import ProductCard from '../components/ProductCard';

const HomePage = () => {
  const products = useSelector((state) => state.products);

  return (
    <main className="py-16">
      <div className="productWrapper">
        <div className="productContainer" id="lws-productContainer">
          {products.length === 0
            ? 'No Product Found'
            : products.map((product) => (
                <ProductCard key={product.id} item={product} />
              ))}
        </div>
        <div>
          <AddProductForm />
        </div>
      </div>
    </main>
  );
};

export default HomePage;
